import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./Table.module.scss";
import { FaSortAmountDown, FaTimes } from "react-icons/fa";
import Slider from "@mui/material/Slider";
import "./index.css";
import { feetInchesToInchesSafe } from "../../utils/feetInches";

const feetInchesToInches = (height) => {
  return feetInchesToInchesSafe(height);
};

const inchesToFeetInches = (inches) => {
  const feet = Math.floor(inches / 12);
  const remainder = inches % 12;
  return `${feet}'${remainder.toFixed(0)}`;
};

const FiltersComponent = ({
  options,
  handleChange,
  currentFilter,
  heightRange,
  handleHeightChange,
  weightRange,
  handleWeightChange,
  wingspanRange,
  handleWingspanChange,
  clearFilters,
  cardClassName,
  popupClassName,
}) => {
  const [showAllFilters, setShowAllFilters] = useState(false);
  const filterProps = {
    heightRange,
    handleHeightChange,
    weightRange,
    handleWeightChange,
    wingspanRange,
    handleWingspanChange,
    clearFilters,
  };

  const toggleAllFilters = () => {
    setShowAllFilters(!showAllFilters);
  };

  const handleSelectFilter = (event, option) => {
    event.stopPropagation();
    handleChange(option.value);
  };

  return (
    <div
      id="filter-card"
      className={[styles.filterCard, cardClassName].filter(Boolean).join(" ")}
      onClick={(e) => {
        e.stopPropagation();
        toggleAllFilters();
      }}
    >
        <div>Sort & Filter</div>
        <div
          style={{
            width: "28px",
            display: "flex",
            justifyContent: "end",
            color: "#212529",
          }}
        >
          <FaSortAmountDown size={14} />
        </div>
        {showAllFilters && (
          <AllFiltersPopup
            options={options}
            selectedFilters={currentFilter}
            selectFilter={(event, value) => handleSelectFilter(event, value)}
            toggleAllFilters={(e) => {
              e.stopPropagation();
              toggleAllFilters();
            }}
            filterProps={filterProps}
            popupClassName={popupClassName}
          />
        )}
    </div>
  );
};

const AllFiltersPopup = ({
  options,
  selectedFilters,
  selectFilter,
  toggleAllFilters,
  filterProps,
  popupClassName,
}) => {
  const popupRef = useRef();
  const {
    heightRange,
    handleHeightChange,
    weightRange,
    handleWeightChange,
    wingspanRange,
    handleWingspanChange,
    clearFilters,
  } = filterProps;
  const handleClickOutside = (event) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      !event.target.closest(`.${styles.filterCard}`)
    ) {
      toggleAllFilters(event);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  return (
    <div
      ref={popupRef}
      className={[styles.popup, popupClassName].filter(Boolean).join(" ")}
    >
      <header>
        <h3>Sort & Filter</h3>
        <FaTimes />
      </header>
      <h4>Sort By</h4>
      {options.map((option) => (
        <div key={option?.value}>
          <label onClick={(event) => selectFilter(event, option)}>
            <input
              type="radio"
              checked={selectedFilters === option.value}
              readOnly
            />
            <p>{option?.name}</p>
          </label>
        </div>
      ))}

      <hr />
      <h4>Filters</h4>

      <div className="slider-column">
        <p>Height</p>
        <Slider
          value={heightRange}
          onChange={handleHeightChange}
          min={feetInchesToInches("4'6")}
          max={feetInchesToInches("8'0")}
          step={1}
          valueLabelDisplay="auto"
          valueLabelFormat={(value) => inchesToFeetInches(value)}
          color="black"
        />
      </div>

      <div className="slider-column">
        <p>Weight Range</p>
        <Slider
          value={weightRange}
          onChange={handleWeightChange}
          min={100}
          max={300}
          step={1}
          valueLabelDisplay="auto"
          color="black"
        />
      </div>

      <div className="slider-column">
        <p>Wingspan Range</p>
        <Slider
          value={wingspanRange}
          onChange={handleWingspanChange}
          min={feetInchesToInches("5'0")}
          max={feetInchesToInches("8'6")}
          step={1}
          valueLabelDisplay="auto"
          valueLabelFormat={(value) => inchesToFeetInches(value)}
          color="black"
        />
      </div>

      <footer>
        <h4
          onClick={(e) => {
            e.stopPropagation();
            clearFilters();
          }}
        >
          Clear All
        </h4>
      </footer>
    </div>
  );
};

export default FiltersComponent;
